export default __webpack_public_path__ + "static/media/paradise-cove.a11a779f.jpg";